<template>
  <div class="text-2sm flex items-center text-text-muted"
       :class="{positive:changedValue > 0,
                negative:changedValue < 0}">
    <svg width="7"
         height="6"
         viewBox="0 0 7 6"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 0L7 6H0L3.5 0Z"/>
    </svg>
    <span class="ml-2">{{ !!changedValue ? changedValue : '– ' }}%</span>
  </div>
</template>

<script>
export default {
  name: "Indicator",
  props: ['changedValue']
}
</script>

<style scoped lang="scss">
.positive {
  @apply text-green;
  svg path {
    fill: #27AE60;
  }
}

.negative {
  @apply text-red;
  svg {
    transform: scale(1, -1);
  }

  svg path {
    fill: #E04067;
  }
}
</style>